import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivate, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';


const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['signin']);
const redirectLoggedInToMain = () => redirectLoggedInTo(['']);
const canAdmin = ()=> pipe(map(idTokenResult => !!idTokenResult))


const routes: Routes = [
  { path: '',
    children:[
      { path: '', loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule), ...canActivate(redirectUnauthorizedToLogin)},
      { path: '', loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule), data: { title: 'Session'}},

      // { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),   ...canActivate(redirectLoggedInToMain)}
    ]
  },
  { path: 'unauthorized', loadChildren: () => import('./sessions/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule) },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
